module.exports = __webpack_public_path__ + "static/media/intro.ef67f722.svg";